import PropTypes from 'prop-types';
import { Outlet, Link } from 'react-router-dom';
import classnames from 'classnames';
import PolestarApp from '@polestar/component-warehouse-react/components/polestar-app/PolestarApp';
import Logo from '@polestar/component-warehouse-react/components/logo/Logo';
import { ThemeTypes } from '@polestar/component-warehouse-react/themes/Theme';
import { useTranslate, useLanguageAndMarket } from '../../i18n';
import { getCookieUrl } from './utils';
import { getContextValue } from '../../utils/globalContext';
import styles from './styles.module.css';

const Layout = ({
  isReady = false,
  direction = 'ltr',
  colorMode = 'light',
}) => {
  const { translate } = useTranslate();
  const pageId = getContextValue('pageId');
  const hideFooterPageIds = ['login'];
  const shouldAddWrapper = hideFooterPageIds.includes(pageId);
  const { market, language } = useLanguageAndMarket();

  const getCopyRightText = () => {
    return translate('footer_copyright').replace(
      '%currentYear%',
      new Date().getFullYear(),
    );
  };

  const getCookieInfo = () => {
    return `<p>${translate('footer_cookieInfo').replace('%cookieUrl%', getCookieUrl(market, language))}</p>`;
  };

  return (
    <PolestarApp
      className={classnames(
        'Polestar',
        shouldAddWrapper && styles.hasWrapper,
        colorMode === 'dark' && 'dark',
      )}
      theme={colorMode === 'dark' ? ThemeTypes.dark : ThemeTypes.light}
    >
      <header className={classnames(styles.header)}>
        <div className={styles.outer}>
          <Link to={getContextValue('REACT_APP_POLESTAR_URL')}>
            <Logo dir={direction} aria-label={translate('logo_label')} />
          </Link>
        </div>
      </header>
      <div className={styles.divider} />
      {isReady && (
        <>
          <main
            dir={direction}
            className={classnames(styles.content, styles.outer)}
          >
            <Outlet />
          </main>
          <footer
            className={classnames('text-secondary', styles.footer)}
            dir={direction}
          >
            <div className={classnames(styles.footerContent, styles.outer)}>
              <p>{getCopyRightText()}</p>
              <div dangerouslySetInnerHTML={{ __html: getCookieInfo() }} />
            </div>
          </footer>
        </>
      )}
    </PolestarApp>
  );
};

Layout.propTypes = {
  isReady: PropTypes.bool.isRequired,
  direction: PropTypes.string.isRequired,
  colorMode: PropTypes.string,
};

export default Layout;
